import TarotEffect from './tarot-effect.js';

export default class CarouselEffect extends TarotEffect {
	static effectName = 'carousel';

	constructor(ctx) {
		super(ctx);
	}

	/**
	 * position all slides on the track using frame-based rendering
	 * runs with every animation frame when track is moving
	 * @param {Object} frame - complete frame object with all data
	 * @param {Array} frame.slides - prepped slides with calculated positions
	 * @param {Object} frame.widths - layout measurements
	 * @param {Object} frame.state - carousel state (selectedIndex, renderIndex, etc.)
	 * @param {Object} frame.animation - animation data
	 * @param {Object} frame.transformPoints - named position points
	 * @param {Object} utils - frame utilities for position calculations
	 * @param {Function} utils.getPointValue - Get absolute position for named point
	 * @param {Function} utils.getRange - Get range between two named points
	 * @param {Function} utils.isSlideInRange - Check if slide is in range with progress
	 * @returns {void}
	 */
	render(frame, utils) {
		const { slides, widths, state, animation } = frame;

		// must call these if you want to set the slide width and track position
		this.renderTrackWidth(widths.track);
		this.renderSlideWidth(widths.slide);
		this.renderTrackPosition(animation);

		// position each slide based on its calculated _trackPosition
		for (let i = 0, n = slides.length; i < n; ++i) {
			const slide = slides[i]; // This is the actual <tarot-slide> DOM element
			if (slide && slide.style) {
				// clear any transitions for immediate positioning
				// slide.style.transition = 'none';

				// position slide using its _trackPosition property (set by frame engine)
				slide.style.transform = `translateX(${slide._trackPosition}px)`;
			}
		}
	}

	destroy() {
		// this.ctx.viewport.style.setProperty('--tarot-slide-width', ``);
		// reset track position
		this.ctx.track.style.transform = '';
		// clear track width
		this.ctx.track.style.width = '';
	}
}
